<template>
    <form>
        <h2>{{$t('UI.edition')}}: </h2>
        <h4 v-if="mode === 'edition'">
            {{$t('COMMON.price')}} id: {{editedPrice.id}}
        </h4>
        <div class="form-group">
            <label for="price">{{$t('COMMON.price')}} ( € )</label>
            <input type="number"
                   placeholder="Price"
                   id="price"
                   @change="$v.editedPrice.price.$touch()"
                   :class="['form-control', {
                        'input-error': $v.editedPrice.price.$invalid
                        && $v.editedPrice.price.$dirty
                   }]"
                   v-model.number="editedPrice.price">
        </div>
        <cph-button @clicked="confirmAction({
                        question: $t('QUESTIONS.updatePrice'),
                        data: {price: editedPrice},
                        callback: updatePriceAsync
                     })"
                    :buttonText="$t('UI.save')"
                    :classList="'btn btn-cph-primary-outline'"
                    :buttonDisabeld="$v.editedPrice.price.$invalid"
                    v-if="$isAllowed('update')">
            
        </cph-button>
        
        <cph-button @clicked="$emit('cancel')"
                    :buttonText="$t('UI.cancel')"
                    :classList="'btn btn-warning'">
        </cph-button>
    </form>
</template>

<script type="text/babel">
import { required } from 'vuelidate/lib/validators';
import { mapGetters, mapActions } from 'vuex';
import { PricesPerimeter } from '../../../router/perimeters/pricesPerimeter';
import CphButton from '../../Shared/UI/Button/CphButton.vue';
import PriceAndProductMixin from '../../../mixins/PriceAndProductMixin.vue';

export default {
    data () {
        return {
            editedPrice: {...this.item}
        };
    },
    props: ['item', 'mode'],
    mixins: [PriceAndProductMixin],
    perimeters: [
        PricesPerimeter
    ],
    components: {
        CphButton
    },
    computed: {
        ...mapGetters({
            productGroups: 'getProductGroups',
            productServicePort: 'getProductPort',
            priceServicePort: 'getPriceServicePort',
            prices: 'getAllPrices',
            products: 'getProducts'
        })
    },
    methods: {
        ...mapActions(['confirmAction']),
        setValues () {
            this.price = this.prices[this.item.product] ? this.prices[this.item.product].price : 0;
            this.editedPrice = Object.assign({}, this.item);
        },
        hasError (type, value) {
            if(type === 'formats' || type === 'type') {
                return value.length <= 0;
            } else if (type === 'price') {
                return value <= 0;
            }
        }
    },
    validations: {
        editedPrice: {
            price: {
                required
            }
        }
    }
};
</script>
